import { getIDToken } from "../utils/utils";
import * as config from "../config.js";

export const getLiveEvents = async (clientID) => {
  const url = `${config.REST_SERVER_URL}/admin/client/liveevents/${clientID}`;
  const response = await fetch(url, {
    method: "GET",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS");
  return results.liveevents;
};

export const getLiveEvent = async (public_id) => {
  // We dispatch requestLogin to kickoff the call to the API
  console.log("!!! liveevent ID: ", public_id);
  const response = await fetch(
    `${config.REST_SERVER_URL}/admin/liveevent/${public_id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Access-Token": getIDToken(),
      },
    }
  );

  const results = await response.json();
  console.log("!!! RESULTS: ", results);

  if (results.success) {
    return results.liveevent;
  }

  return null;
};

export const saveLiveEvent = async (liveevent) => {
  // We dispatch requestLogin to kickoff the call to the API
  //dispatch(requestLogin(creds));

  const method = liveevent.public_id ? "PUT" : "POST";
  const url = liveevent.public_id
    ? `${config.REST_SERVER_URL}/admin/liveevent/${liveevent.public_id}`
    : `${config.REST_SERVER_URL}/admin/liveevent`;
  const response = await fetch(url, {
    method: method,
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify(liveevent),
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  if (results.success) {
    return results.liveevent;
  }
  return false;
};

export const deleteLiveEvent = async (public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/${public_id}`;
  const response = await fetch(url, {
    method: "DELETE",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const createLiveEvents = async (liveevents) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/bulk_create`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({ liveevents: liveevents }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const getAgentAnswer = async (public_id, question) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/agent/answer/${public_id}`;
  console.log("!!! AGENT ANSWER URL: ", url);
  console.log("!!! QUESTION: ", question);
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": getIDToken(),
    },
    body: JSON.stringify({ question }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  console.log("!!! RESULTS: ", results);
  return results;
};

export const endLiveEventOnServer = async (token, public_id) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/end/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": token,
    },
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};

export const saveVideoToLiveEvent = async (token, public_id, base64) => {
  const url = `${config.REST_SERVER_URL}/admin/liveevent/add-video/${public_id}`;
  const response = await fetch(url, {
    method: "POST",
    crossDomain: true,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": token,
    },
    body: JSON.stringify({
      video_data: base64,
      video_file_name: `recording-${Date.now()}.webm`,
    }),
  }).catch((error) => {
    console.log("ERROR: ", error);
  });

  const results = await response.json();
  return results;
};
